<template>
    <div class="col-sm-4">
        <div class="Product">
            <div class="Product-Image">
                <a :href="'#/product/' + moduleId + '/' + product.product_id">
                    <img class="img-responsive" :src="picture" :alt="product.name">
                </a>
            </div>

            <div class="Product-Caption">
                <p>
                    <span class="Product-Price" :class="{'Product-Price--Disabled': product.is_disabled}">
                        {{ price | formatCurrency(currency) }}
                        <!-- formatCurrency is a filter declared in main.js -->
                    </span>

                    <span class="Product-Name">{{ product.name }}</span>
                </p>
            </div>
        </div>
    </div>

</template>

<script>
  export default {
    props: {
      product: {
        type: Object,
        required: true
      },
      currency: {
        type: String,
        required: false,
      },
      moduleId: {},
      apiUrl: {}
    },

    computed: {
      price () {
        return this.product.is_disabled ? 'Satışa kapalı' : this.getPrice();
      },
      picture () {
        let images = this.product.image;

        if (images.hasOwnProperty('default')) {
          let index = images.default ? images.default : 0;
          return this.apiUrl + 'data/' + images.listOfImages[index];
        }

        if (Array.isArray(images) && images.length) {
          return this.apiUrl + 'data/' + images[0];
        }

        return '/static/default_product.jpg';
      }
    },

    methods: {
      getPrice () {
        let price = this.product.price;

        if (this.product.price_list) {
          let values = this.product.price_list_data.values;
          price = values[0].value + ' - ' + values[values.length - 1].value;
        }

        return price;
      }
    }
  };
</script>

<style scoped>
    .Product {
        /*    background-color: lightgray;
        border: 1px solid gray;*/
        /*width: 30%;*/
        margin-bottom: 10px;
        /*border-bottom: solid 1px #ddd;*/
    }

    .Product-Image {
        /*height: 300px;*/
        /*display: flex;*/
        align-items: center;
        justify-content: center;
        border: 1px solid #eaeaea;
        position: relative;
        overflow: hidden;
    }

    .Product-Image img {
        width: 100%;
    }

    .Product-Price {
        background-color: #7f8c8d;
        padding: 4px 10px;
        color: #fff;
        margin-right: 5px;
        margin-bottom: 15px;
    }

    .Product-Price--Disabled {
        background-color: red;
    }

    .Product-Caption {
        font-weight: 600;
        margin: 20px 0;
        /*margin-top: 5%;*/
        /*margin-bottom: 10%;*/
    }

    .Product-Name {
        text-transform: uppercase;
        color: #7f8c8d;
        background-color: #FFF;
        padding: 4px 10px;
    }
</style>



// WEBPACK FOOTER //
// type3.vue?59f43e0d